import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { Box, CircularProgress } from '@mui/material';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  const token = localStorage.getItem('token');
  const decodedToken = token ? JSON.parse(atob(token.split('.')[1])) : null;
  const userRole = decodedToken ? decodedToken.role?.toLowerCase() : null;

  const allowedRoutesForCDI = [
    '/',
    '/paie',
    '/documents',
    '/ajouterdeclarations',
    '/ajouterpaie',
    '/ajouterdocuments',
    '/AjouterMaladie'
  ];  
  
  if (userRole === 'cdi') {
    const path = decodeURIComponent(location.pathname).toLowerCase();
  
    const isAllowed = allowedRoutesForCDI.some(allowedPath =>
      path === allowedPath.toLowerCase() || path.startsWith(allowedPath.toLowerCase() + '/')
    );
  
    if (!isAllowed && path !== '/déclarations') { // autorise /Déclarations pour tous
      console.warn(`CDI bloqué : tentative d'accès à ${location.pathname}`);
      return <Navigate to="/" replace />;
    }
  }  

  if (loading) {
  return children;
}

return isAuthenticated ? children : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
